<template>
    <div>
        <van-popup
            v-model="addressPopup"
            :close-on-click-overlay="false"
            :style="{ height: '60%' }"
            position="bottom"
        >
            <div class="chooseAddress-w">
                <div class="title-fixed">
                    <p>
                        配送至
                        <i @click="closePopup"></i>
                    </p>
                    <div class="address-text">
                        <span class="adr-item" :style="{ color: color }" v-for="(item,index) in addrArr" :key="index" @click="chooseAdrItem(item.c)">{{ item.n }}</span>
                        <span v-if="addrArr.length === 0">请选择</span>
                    </div>
                </div>
                <div class="address-content2">
                    <div class="address-box">
                        <div
                            class="address-item"
                            v-for="(item, index) in addressList"
                            :key="item.c"
                            :class="{ active: index === activeIndex }"
                            @click="chooseAddress(item)"
                        >
                            <span>{{ item.n }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import http from '../../common/http.js'
export default {
    name: 'addressTemp',
    props: {
        addressPopup: {
            type: Boolean,
            default: false
        },
        addr: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: []
        },
        color: {
            type: String,
            default: '#53acfe'
        }
    },
    data(){
        return{
            activeIndex: null,
            addressList: [],
            addrText: '',
            addrArr: [],
            province: '',
            city: '',
            area: '',
            town: ''
        }
    },
    created() {
        this.addrArr = this.addr
        if (this.addr.length < 4) {
            this.addrArr = []
            this.getAddrLibrary()
        } else {
            this.getAddrLibrary(this.addr[this.addr.length - 2].c, false)
        }
        
    },
    methods:{
        //获取地址库
        getAddrLibrary(root, state) {
            let key = ''
            if (root) {
                key = `?key=${root}`
            } else {
                key = ''
            }
            http.get('storage/public/address/base' + key).then(res =>{
                if (res.code === 0) {
                    if (res.data === null) {
                        if (state) {
                            this.$emit('closePopup')
                            this.$emit('getAddr', this.addrArr)
                            this.restData()
                        }
                    } else {
                        this.addressList = res.data
                    }
                }
            })
        },
        //点击选择地址
        chooseAddress(item) {
            this.addrText += item.n
            if (this.addrArr.length < 4) {
                this.addrArr.push(item)
            }
            if (this.addrArr.length === 4) {
                this.addrArr.splice(3, 1)
                this.addrArr.push(item)
            }
            this.getAddrLibrary(item.c, true)
        },
        // 点击选择好的省市区重新更换
        chooseAdrItem(code) {
            if (code.length === 2) {
                this.getAddrLibrary()
                this.addrArr = []
            }
            if (code.length === 4) {
                this.getAddrLibrary(this.addrArr[0].c)
                this.addrArr.splice(1, this.addrArr.length - 1) 
            }
            if (code.length === 6) {
                this.getAddrLibrary(this.addrArr[1].c)
                this.addrArr.splice(2, this.addrArr.length - 1) 
            }
            // this.addrArr.splice(index + 1, this.addrArr.length - 1)
        },
        closePopup() {
            this.$emit('closePopup')
            // this.restData()
        },
        restData() {
            this.addrText = ''
            this.addressList = []
            this.addrArr = []
            this.getAddrLibrary()
        }
    }
}
</script>
<style lang="less" scoped>
.chooseAddress-w {
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    height: 100%;
    .title-fixed {
        position: fixed;
        background: #fff;
        width: 100%;
        z-index: 10;
        p {
            border-bottom: 1px solid #ececec;
            padding-left: 0.21rem;
            font: bold 0.32rem/0.9rem PingFangSC-Medium;
            text-align: center;
            i {
                display: block;
                width: 20px;
                height: 20px;
                background: url('../../image/Gb@2x.png') no-repeat;
                background-size: contain;
                float: right;
                margin: 0.21rem 0.3rem 0 0;
            }
        }
        .address-text {
            height: 50%;
            line-height: 0.68rem;
            border-bottom: 1px solid #ececec;
            padding: 0 0.3rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: visible;
            font-size: 12px;
            .adr-item {
                margin-right: 15px;
                color: #53acfe;
            }
        }
    }
    .address-content2 {
        font-size: 12px;
        display: flex;
        // border: 1px solid red;
        flex: 1;
        // overflow: hidden;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        .address-box {
            height: 8rem;
            margin-right: 5px;
            padding: 90px 20px 20px;
             min-height: fit-content;
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-track {
                background: rgb(239, 239, 239);
                border-radius: 2px;
            }
            &::-webkit-scrollbar-thumb {
                background: #bfbfbf;
                border-radius: 10px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #333;
            }
            &::-webkit-scrollbar-corner {
                background: #179a16;
            }
            .address-item {
                height: 0.68rem;
                line-height: 0.68rem;
                &.active {
                    color: #53acfe;
                }
                span {
                    display: block;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .ceshis {
                width: 100%;
                height: 100px;
            }
        }
    }
}
</style>

